var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pt-20 p-5 w-11/12 overflow-y-scroll" }, [
    _c("div", { staticClass: "mt-2" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col md:flex-row border-b border-gray-200" },
        [
          _c(
            "div",
            { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
            [_vm._v("New Password")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
            _c("div", { staticClass: "w-full flex-1 mx-2" }, [
              _c("div", { staticClass: "my-2 p-1 flex flex-col" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm.$v.input.new_password.$dirty &&
                  !_vm.$v.input.new_password.required
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("New Password is required")]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-1" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.input.new_password,
                        expression: "input.new_password"
                      }
                    ],
                    staticClass:
                      "block border border-grey-light w-full p-3 rounded",
                    class:
                      _vm.$v.input.new_password.$dirty &&
                      !_vm.$v.input.new_password.required
                        ? "border-red-500"
                        : "",
                    attrs: {
                      type: "password",
                      name: "new_password",
                      placeholder: "New Password",
                      disabled: _vm.isLoading
                    },
                    domProps: { value: _vm.input.new_password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.input, "new_password", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col md:flex-row border-b border-gray-200" },
        [
          _c(
            "div",
            { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
            [_vm._v("Confirm New Password")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
            _c("div", { staticClass: "w-full flex-1 mx-2" }, [
              _c("div", { staticClass: "my-2 p-1 flex flex-col" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm.$v.input.confirm_new_password.$dirty &&
                  !_vm.$v.input.confirm_new_password.sameAsPassword
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("Confirm New Password not match")]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-1" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.input.confirm_new_password,
                        expression: "input.confirm_new_password"
                      }
                    ],
                    staticClass:
                      "block border border-grey-light w-full p-3 rounded",
                    class:
                      _vm.$v.input.confirm_new_password.$dirty &&
                      !_vm.$v.input.confirm_new_password.sameAsPassword
                        ? "border-red-500"
                        : "",
                    attrs: {
                      type: "password",
                      name: "confirm_new_password",
                      placeholder: "Confirm New Password",
                      disabled: _vm.isLoading
                    },
                    domProps: { value: _vm.input.confirm_new_password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.input,
                          "confirm_new_password",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex flex-col md:flex-row " }, [
        _c(
          "div",
          { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
          [
            _c(
              "button",
              {
                staticClass:
                  "text-sm  mx-2 w-64  focus:outline-none flex justify-center px-4 py-2 rounded font-bold cursor-pointer\n                        bg-teal-700 text-teal-100\n                        hover:bg-teal-100\n                        hover:text-teal-700\n                          border duration-200 ease-in-out\n                        border-teal-600 transition",
                attrs: { disabled: _vm.isLoading },
                on: { click: _vm.changePassword }
              },
              [_vm._v("\n          Update Password\n          ")]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "flex flex-col justify-between md:flex-row border-b border-gray-200 py-3"
      },
      [_c("h1", { staticClass: "flex text-3xl" }, [_vm._v("Change Password")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45d36ce0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45d36ce0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ChangePasswordUser.vue
// module id = null
// module chunks = 